import { PlanningState, AIPlan, PlanningContext, ActionCandidate, AIActionType } from "@/core/battle/ai/types/ai.types";
import { idToCoords } from "@/core/utils/hex.utils";

/**
 * Simulates action outcomes for planning
 */
export class StateSimulator {
    
    simulate(
        state: PlanningState,
        candidate: ActionCandidate,
    ): PlanningState {

        if (candidate.action.type === AIActionType.Move) {
            return this.simulateMove(state, candidate);
        }
        
        if (candidate.action.type === AIActionType.Attack) {
            return this.simulateAttack(state, candidate);
        }

        if (candidate.action.type === AIActionType.Wait) {
            return this.simulateWait(state, candidate);
        }
        
        return state; // Wait
    }
    
    private simulateMove(
        state: PlanningState,
        candidate: ActionCandidate,
    ): PlanningState {
        
        return {
            position: candidate.position,
            stamina: candidate.staminaAfter,
            actionsUsed: [...state.actionsUsed, candidate.action],
            totalUtility: state.totalUtility,
            depth: state.depth + 1
        };
    }
    
    private simulateAttack(
        state: PlanningState,
        candidate: ActionCandidate,
    ): PlanningState {
        // Simulate attack (stamina cost, position stays same)
        return {
            position: candidate.position,
            stamina: candidate.staminaAfter,
            actionsUsed: [...state.actionsUsed, candidate.action],
            totalUtility: state.totalUtility,
            depth: state.depth + 1
        };
    }

    private simulateWait(
        state: PlanningState,
        candidate: ActionCandidate,
    ): PlanningState {
        // Simulate wait (stamina cost, position stays same)
        return {
            position: candidate.position,
            stamina: candidate.staminaAfter,
            actionsUsed: [...state.actionsUsed, candidate.action],
            totalUtility: state.totalUtility,
            depth: state.depth + 1
        };
    }
}